import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "itm-speech.firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "itm-speech",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "itm-speech.firebasestorage.app",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "739711353305",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "1:739711353305:web:4b14b68e0efbba499a99c8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app, 'website-data-do');

export { db };
